import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { Box } from '../../Box/index.js';
import { useTheme } from '../../hooks/useTheme.js';

var LayoutContent = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(props, {
        themeKey: "layoutContent",
    });
    return (jsx(Box, __assign({ "data-component": "LayoutContent", as: "main", id: "main" }, forwardProps, props, { children: children })));
};

export { LayoutContent };
//# sourceMappingURL=index.js.map
